import { render, staticRenderFns } from "./addressVue.vue?vue&type=template&id=9f7ddb98&"
import script from "./addressVue.vue?vue&type=script&lang=js&"
export * from "./addressVue.vue?vue&type=script&lang=js&"
import style0 from "./addressVue.vue?vue&type=style&index=0&id=9f7ddb98&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports